import { IRootState } from "../interfaces";

export const getInvoiceDraft = (state: IRootState) => state.invoiceReducer.draft;

export const getInvoices = (state: IRootState) => state.invoiceReducer.invoices;

export const getInvoice = (state: IRootState) => state.invoiceReducer.invoice;
